function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getApiBaseUrl } from 'shared/helper/request';
var params = "?redirect_uri=".concat(window.location.origin, "/login?logout=1");
var replaceLang = function replaceLang(languageCode) {
  return Object.entries(navBar).reduce(function (carry, section) {
    // section = [authoringServices, {title, links}]
    var links = section[1].links.map(function (link) {
      return _objectSpread(_objectSpread({}, link), {}, {
        url: link.url.replace(':lang', languageCode)
      });
    });

    // @TODO CUSTOMER-8835 remove this
    for (var i = 0; i < links.length; i += 1) {
      if (links[i].text === 'Digital Editing' && languageCode === 'cn') {
        links[i].url = 'https://www.aje.com/cn/services/digital-editing';
        break;
      }
    }
    // @TODO CUSTOMER-8835 end of block

    return _objectSpread(_objectSpread({}, carry), {}, _defineProperty({}, section[0], _objectSpread(_objectSpread({}, section[1]), {}, {
      links: links
    })));
  }, {});
};
var navBar = {
  account: {
    links: [{
      icon: '',
      text: 'My Orders',
      url: '/researcher'
    }, {
      icon: '',
      text: 'My Invoices',
      url: '/researcher/invoices'
    }, {
      icon: '',
      text: 'My Account',
      url: '/account'
    }, {
      icon: '',
      text: 'my aje rewards',
      url: '/researcher/rewards'
    }, {
      icon: '',
      text: 'My Digital Editing',
      url: '/researcher/digital-editing'
    }, {
      icon: '',
      text: 'My Prepay and Credits',
      url: '/researcher/prepay'
    }, {
      icon: '',
      text: 'Refer a Colleague',
      url: '/referral-rewards'
    }, {
      icon: '',
      text: 'Logout',
      url: "".concat(getApiBaseUrl(), "/api/auth/logout").concat(params)
    }]
  },
  accountAJE: {
    title: 'my-aje',
    links: [{
      icon: '',
      text: 'My Orders',
      url: '/researcher'
    }, {
      icon: '',
      text: 'My Invoices',
      url: '/researcher/invoices'
    }, {
      icon: '',
      text: 'Refer a Colleague',
      url: '/referral-rewards'
    }, {
      icon: '',
      text: 'my aje rewards',
      url: '/researcher/rewards'
    }, {
      icon: '',
      text: 'My Prepay and Credits',
      url: '/researcher/prepay'
    }]
  },
  accountCurie: {
    title: 'my-curie',
    links: [{
      icon: '',
      text: 'workspace',
      url: '/:lang/rubriq'
    }, {
      icon: '',
      text: 'my-plan',
      url: '/:lang/rubriq/plan'
    }, {
      icon: '',
      text: 'My Orders',
      url: '/rubriq/invoices'
    }]
  },
  accountGrouped: {
    title: 'my account',
    links: [{
      icon: '',
      text: 'settings',
      url: '/account'
    }, {
      icon: '',
      text: 'log out',
      url: "".concat(getApiBaseUrl(), "/api/auth/logout").concat(params)
    }]
  },
  solutions: {
    title: '',
    links: [{
      text: 'Manuscript',
      url: 'https://www.aje.com/:lang/services/manuscripts/'
    }, {
      text: 'Grant Application',
      url: 'https://www.aje.com/:lang/services/grants/'
    }, {
      text: 'Thesis',
      url: 'https://www.aje.com/:lang/services/theses/'
    }, {
      text: 'Abstract',
      url: 'https://www.aje.com/:lang/services/abstracts/'
    }, {
      text: 'Academic Book',
      url: 'https://www.aje.com/:lang/services/book-editing/'
    }, {
      text: 'Research Promotion',
      url: 'https://www.aje.com/:lang/services/research-promotion/'
    }, {
      text: 'Research Quality Evaluation',
      url: 'https://www.aje.com/:lang/services/research-quality-evaluation/'
    }]
  },
  professionalEditing: {
    title: 'Professional Editing',
    links: [{
      text: 'Standard Editing',
      url: 'https://www.aje.com/:lang/services/editing/'
    }, {
      text: 'Premium Editing',
      url: 'https://www.aje.com/:lang/services/editing/'
    }, {
      text: 'VIP Editing',
      url: 'https://www.aje.com/:lang/services/vip-editing/'
    }, {
      text: 'Scientific Editing',
      url: 'https://www.aje.com/:lang/services/scientific-editing/'
    }, {
      text: 'Academic Translation',
      url: 'https://www.aje.com/:lang/services/translation/'
    }]
  },
  additionalServices: {
    title: 'Additional Services',
    links: [{
      text: 'Pre-Submission Peer Review',
      url: 'https://www.aje.com/services/pre-submission-peer-review/'
    }, {
      text: 'Presubmission Review',
      url: 'https://www.aje.com/:lang/services/presubmission-review/'
    }, {
      text: 'Journal Recommendation',
      url: 'https://www.aje.com/:lang/services/journal-recommendation/'
    }, {
      text: 'Manuscript Formatting',
      url: 'https://www.aje.com/:lang/services/formatting/'
    }, {
      text: 'Figure and Table Formatting',
      url: 'https://www.aje.com/:lang/services/figures/'
    }]
  },
  researchPromotion: {
    title: 'Research Promotion',
    links: [{
      text: 'Video Bytes',
      url: 'https://www.aje.com/:lang/services/research-promotion/',
      uniqueId: 'video-bytes'
    }, {
      text: 'Graphical Abstracts',
      url: 'https://www.aje.com/:lang/services/research-promotion/',
      uniqueId: 'graphical-abstracts'
    }]
  },
  fundingServices: {
    title: 'Funding Services',
    links: [{
      text: 'Grant Services',
      url: 'https://www.aje.com/:lang/services/grants/'
    }]
  },
  automatedTools: {
    title: 'Automated Tools',
    links: [{
      text: 'Grammar Check',
      url: 'https://www.aje.com/:lang/grammar-check/'
    }]
  },
  curieServices: {
    title: 'Rubriq',
    links: [{
      icon: '',
      text: 'About & Pricing',
      url: 'https://www.aje.com/:lang/Rubriq'
    }]
  },
  formattingServices: {
    title: 'Formatting Services',
    links: [{
      text: 'Manuscript Formatting',
      url: 'https://www.aje.com/:lang/services/formatting'
    }]
  },
  preCurieLaunchAutomatedTools: {
    title: 'Automated Tools',
    links: [{
      icon: 'fa-light fa-microchip-ai',
      text: 'Digital Editing',
      url: 'https://www.aje.com/:lang/services/digital'
    }, {
      icon: 'fa-light fa-microchip-ai',
      text: 'Digital Translation + Editing',
      url: 'https://www.aje.com/:lang/services/digital-translation'
    }, {
      icon: 'fa-light fa-microchip-ai',
      text: 'Grammar Check',
      url: 'https://www.aje.com/:lang/grammar-check'
    }]
  },
  learnLinks: {
    title: 'Education',
    links: [{
      icon: '',
      text: 'Blog',
      url: 'https://www.aje.com/:lang/arc/'
    }, {
      icon: '',
      text: 'Ebooks,Guides and More',
      url: 'https://www.aje.com/:lang/resource-center/'
    }, {
      icon: '',
      text: 'Webinars',
      url: 'https://www.aje.com/:lang/webinars/'
    }, {
      icon: '',
      text: 'Help Center',
      url: 'https://support.aje.com/hc/en-us'
    }]
  },
  whyAje: {
    title: 'Why AJE?',
    links: [{
      icon: '',
      text: 'What Sets Us Apart',
      url: 'https://www.aje.com/:lang/about/what-sets-us-apart/'
    }, {
      icon: '',
      text: 'Areas of Study',
      url: 'https://www.aje.com/:lang/about/areas-of-study/'
    }, {
      icon: '',
      text: 'Testimonials',
      url: 'https://www.aje.com/:lang/testimonials/'
    }]
  },
  about: {
    title: '',
    links: [{
      icon: '',
      text: 'About AJE',
      url: 'https://www.aje.com/:lang/about/'
    }, {
      icon: '',
      text: 'Careers',
      url: 'https://www.indeed.com/cmp/:lang/American-Journal-Experts-(aje)-1'
    }, {
      icon: '',
      text: 'Contact Us',
      url: 'https://support.aje.com/hc/en-us/requests/new?ticket_form_id=360000087311'
    },
    // { icon: '', text: 'Our Team', url: 'https://www.aje.com/:lang/about/our-team/' },
    {
      icon: '',
      text: 'Legal',
      url: 'https://www.aje.com/:lang/terms-of-service/'
    }]
  },
  companyLinks: {
    title: 'Company',
    links: [{
      icon: '',
      text: 'About AJE',
      url: 'https://www.aje.com/:lang/about'
    }, {
      icon: '',
      text: 'Careers',
      url: 'https://recruiting.paylocity.com/Recruiting/Jobs/All/32fe5d7d-8136-4f15-9032-90640e9b9370'
    }, {
      icon: '',
      text: 'What Sets us Apart',
      url: 'https://www.aje.com/:lang/about/what-sets-us-apart'
    }]
  }
};
export default replaceLang;